{
	"title": "Orders",
	"description": "Alle bestellingen uit de shop: betaling, verzending en historie.",
	"searchLabel": "Zoek op ordernummer, naam, e-mailadres of bedrijf",
	"empty": "Er zijn nog geen orders.",
	"column": {
		"number": "Order",
		"placedAt": "Datum",
		"customer": "Klant",
		"total": "Bedrag",
		"payment": "Betaling",
		"shipment": "Verzending",
		"status": "Status"
	},
	"paymentStatus": {
		"label": "Betaalstatus",
		"open": "Open",
		"paid": "Betaald",
		"on_account": "Op rekening",
		"partially_refunded": "Deels terugbetaald",
		"refunded": "Terugbetaald",
		"expired": "Verlopen"
	},
	"shipmentStatus": {
		"label": "Verzendstatus",
		"to_ship": "Te verzenden",
		"shipped": "Verzonden"
	},
	"orderStatus": {
		"label": "Orderstatus",
		"open": "Open",
		"completed": "Afgerond",
		"cancelled": "Geannuleerd"
	},
	"paymentMethod": {
		"ideal": "iDEAL",
		"bancontact": "Bancontact",
		"card": "Creditcard",
		"paypal": "PayPal",
		"bankTransfer": "Overboeking",
		"onAccount": "Op rekening"
	},
	"carrier": {
		"postnl": "PostNL",
		"dhl": "DHL",
		"dpd": "DPD",
		"bpost": "Bpost"
	},
	"detail": {
		"placedAt": "Geplaatst op {{date}}",
		"lines": "Regels",
		"product": "Product",
		"quantity": "Aantal",
		"unitPrice": "Stukprijs",
		"vat": "Btw",
		"lineTotal": "Totaal",
		"lineDiscount": "Korting {{amount}}",
		"vatRate": "{{rate}}%",
		"pricesIncl": "Prijzen inclusief btw.",
		"pricesExcl": "Prijzen exclusief btw.",
		"reverseCharge": "Btw verlegd.",
		"goods": "Artikelen",
		"discount": "Korting",
		"discountWithCode": "Korting ({{code}})",
		"shipping": "Verzendkosten",
		"freeShipping": "Gratis",
		"totalExcl": "Totaal exclusief btw",
		"vatAt": "Btw {{rate}}%",
		"totalIncl": "Totaal inclusief btw",
		"contact": "Klant",
		"name": "Naam",
		"email": "E-mailadres",
		"phone": "Telefoonnummer",
		"noPhone": "Niet opgegeven",
		"toCustomer": "Naar de klant",
		"shippingAddress": "Verzendadres",
		"billingAddress": "Factuuradres",
		"invoice": "Factuur",
		"invoiceLater": "De factuur komt er zodra de order betaald is.",
		"recipient": "t.a.v. {{name}}",
		"country": {
			"NL": "Nederland",
			"BE": "België"
		},
		"addresses": "Adressen"
	},
	"payment": {
		"title": "Betaling",
		"method": "Betaalmethode",
		"status": "Betaalstatus",
		"paidAt": "Betaald op",
		"expiresAt": "Verloopt op",
		"transactions": "Transacties bij Pay.nl",
		"noTransactions": "Nog geen transactie bij Pay.nl.",
		"transaction": "{{method}} · {{amount}} · {{status}}",
		"transactionId": "Transactie {{id}}",
		"testMode": "Testmodus",
		"startedAt": "Gestart {{date}}",
		"transactionStatus": {
			"open": "open",
			"authorized": "geautoriseerd",
			"paid": "betaald",
			"cancelled": "geannuleerd",
			"expired": "verlopen",
			"failed": "mislukt",
			"partially_refunded": "deels terugbetaald",
			"refunded": "terugbetaald"
		},
		"dueOn": "Te betalen vóór",
		"credited": "Gecrediteerd",
		"creditDownload": "Pdf downloaden",
		"openInvoices": "Openstaande facturen"
	},
	"tracking": {
		"title": "Verzending",
		"description": "Vul de vervoerder en de trackingcode in. De klant krijgt dan een track-en-tracemail.",
		"carrier": "Vervoerder",
		"code": "Trackingcode",
		"save": "Opslaan en klant mailen",
		"correct": "Trackingcode wijzigen",
		"saveCorrection": "Opslaan",
		"cancel": "Annuleren",
		"mailCustomer": "Klant opnieuw mailen met deze trackingcode",
		"mailCustomerHelp": "Laat dit uit als de klant de code niet hoeft te weten, bijvoorbeeld bij een tikfout die je meteen ziet.",
		"current": "Verzonden met {{carrier}}",
		"follow": "Volg het pakket",
		"notShippable": "Een trackingcode vul je in zodra de order betaald is.",
		"cancelled": "Deze order is geannuleerd.",
		"notShippableError": "Deze order is (nog) niet betaald, is geannuleerd of wacht op de controle van het verzendadres.",
		"awaitingAddressCheck": "Deze order op rekening gaat naar een verzendadres dat niet in het adresboek van de klant staat. Verzenden kan pas als je het adres hebt gecontroleerd; twijfel je, bel dan eerst de klant.",
		"saved": "Trackingcode opgeslagen."
	},
	"history": {
		"title": "Historie",
		"empty": "Nog niets gebeurd.",
		"by": "{{name}} · {{date}}",
		"system": "Systeem · {{date}}",
		"kind": {
			"placed": "Geplaatst",
			"paid": "Betaald",
			"expired": "Verlopen",
			"cancelled": "Geannuleerd",
			"shipped": "Verzonden",
			"trackingChanged": "Trackingcode gewijzigd",
			"note": "Notitie",
			"reminderSent": "Betalingsherinnering",
			"refunded": "Terugbetaald",
			"refundFailed": "Terugbetaling mislukt",
			"shippingAddressChecked": "Verzendadres gecontroleerd"
		},
		"mail": {
			"sent": "Mail verstuurd",
			"simulated": "Mail gelogd (niet verstuurd buiten productie)",
			"pending": "Mail wordt verstuurd",
			"failed": "Mail mislukt"
		},
		"mailTo": "{{subject}} · aan {{recipient}}"
	},
	"note": {
		"field": "Notitie",
		"add": "Notitie toevoegen"
	},
	"cancel": {
		"title": "Annuleren",
		"description": "Een onbetaalde order annuleer je hier. De voorraad en de kortingscode komen dan vrij.",
		"paidDescription": "Deze order is betaald. Annuleren betaalt alles wat nog over is terug via Pay.nl, met een creditfactuur.",
		"action": "Order annuleren",
		"confirmTitle": "{{orderNumber}} annuleren?",
		"confirmDescription": "De gereserveerde voorraad en het gebruik van de kortingscode komen vrij. Dit kun je niet ongedaan maken.",
		"confirm": "Ja, order annuleren",
		"notCancellable": "Deze order is intussen betaald of verlopen en kan niet meer geannuleerd worden.",
		"reason": "Reden (optioneel)",
		"reasonDescription": "Komt in de historie van de order. De klant ziet hem niet.",
		"shippedDescription": "Deze order is al verzonden. Betaal de teruggestuurde regels terug bij Terugbetalingen.",
		"onAccountDescription": "Deze order staat op rekening en is nog niet verzonden. Annuleren maakt een creditfactuur voor de openstaande factuur en boekt de voorraad terug. Er gaat niets via Pay.nl.",
		"onAccountConfirmDescription": "Factuur {{invoiceNumber}} wordt gecrediteerd met een creditfactuur, die de klant per mail krijgt. De voorraad gaat terug. Dit kun je niet ongedaan maken.",
		"onAccountConfirmDescriptionNoInvoice": "De openstaande factuur wordt gecrediteerd met een creditfactuur, die de klant per mail krijgt. De voorraad gaat terug. Dit kun je niet ongedaan maken.",
		"onAccountConfirm": "Ja, annuleren met creditfactuur",
		"notNow": "Deze order kan nu niet geannuleerd worden."
	},
	"invoice": {
		"number": "Factuurnummer",
		"issuedOn": "Factuurdatum",
		"download": "Pdf downloaden",
		"missing": "Deze order is betaald maar heeft nog geen factuur.",
		"create": "Factuur maken",
		"createFailed": "De factuur kon niet gemaakt worden. Probeer het opnieuw.",
		"confirmationPending": "De factuur is gemaakt, maar de klant heeft de bevestiging met de factuur nog niet gekregen.",
		"confirmationNotSentTitle": "Factuur gemaakt, bevestiging niet verstuurd",
		"confirmationNotSent": "De factuur staat klaar, maar de pdf of de mail met de bevestiging lukte niet. De klant heeft nog niets gekregen. Probeer het opnieuw met Bevestiging versturen.",
		"sendConfirmation": "Bevestiging versturen",
		"confirmationFailed": "Dat lukte niet. Probeer het opnieuw.",
		"loadFailed": "De factuur kon niet geladen worden.",
		"dueOn": "Te betalen vóór",
		"paidOn": "Betaald op",
		"open": "Nog niet betaald",
		"credited": "Gecrediteerd",
		"creditedWith": "{{number}} van {{date}}",
		"creditDownload": "Creditfactuur downloaden"
	},
	"refund": {
		"title": "Terugbetalingen",
		"action": "Terugbetalen",
		"none": "Nog niets terugbetaald.",
		"line": "{{quantity}} × {{name}}",
		"shippingLine": "verzendkosten",
		"exclVat": "{{amount}} excl. btw",
		"restocked": "voorraad teruggeboekt",
		"notRestocked": "voorraad niet teruggeboekt",
		"reasonShown": "Reden: {{reason}}",
		"creditInvoice": "Creditfactuur {{number}} van {{date}}",
		"status": {
			"pending": "Onzeker",
			"succeeded": "Terugbetaald",
			"failed": "Mislukt"
		},
		"dialogTitle": "{{orderNumber}} terugbetalen",
		"dialogDescription": "Kies wat je terugbetaalt. Het bedrag gaat via Pay.nl terug naar de klant, die een creditfactuur krijgt.",
		"cancelTitle": "{{orderNumber}} annuleren",
		"cancelDescription": "Alles wat nog over is gaat via Pay.nl terug naar de klant, verzendkosten inbegrepen. Daarna is de order geannuleerd. Dit kun je niet ongedaan maken.",
		"lines": "Regels",
		"selectAll": "Alles",
		"ordered": "{{quantity}} × {{price}} besteld",
		"alreadyRefunded": "{{quantity}} al terugbetaald",
		"nothingLeft": "Al terugbetaald",
		"quantity": "Aantal {{name}} terugbetalen, hoogstens {{max}}",
		"less": "Eén {{name}} minder",
		"more": "Eén {{name}} meer",
		"of": "van {{max}}",
		"shipping": "Verzendkosten terugbetalen",
		"restock": "Voorraad terugboeken",
		"restockHelp": "Zet dit uit als de artikelen beschadigd zijn of niet terugkomen.",
		"reason": "Reden (komt op de creditfactuur)",
		"totalExcl": "Exclusief btw",
		"totalIncl": "Terug naar de klant",
		"creditInvoiceFollows": "De klant krijgt een creditfactuur per mail.",
		"confirm": "{{amount}} terugbetalen",
		"cancelConfirm": "{{amount}} terugbetalen en annuleren",
		"chooseFirst": "Kies wat je terugbetaalt",
		"error": {
			"rejected": "Pay.nl heeft de terugbetaling geweigerd. Er is niets veranderd.",
			"unavailable": "Pay.nl was niet bereikbaar. Er is niets veranderd; probeer het zo nog eens.",
			"uncertain": "Het antwoord van Pay.nl is niet aangekomen. Kijk in Pay.nl of de terugbetaling gelukt is en geef het hieronder aan.",
			"inProgress": "Er loopt al een terugbetaling voor deze order. Rond die eerst af.",
			"changed": "De order is intussen veranderd. Sluit dit venster en probeer het opnieuw.",
			"failed": "De terugbetaling is niet gelukt. Probeer het opnieuw."
		},
		"resolve": {
			"description": "Kijk in Pay.nl of deze terugbetaling gedaan is, en geef het hier aan.",
			"refunded": "Wel terugbetaald",
			"refundedTitle": "{{amount}} is terugbetaald?",
			"refundedDescription": "De terugbetaling gaat door: creditfactuur, voorraad en status volgen, en de klant krijgt de creditfactuur.",
			"notRefunded": "Niet terugbetaald",
			"notRefundedTitle": "Niet terugbetaald?",
			"notRefundedDescription": "De terugbetaling vervalt. Daarna kun je opnieuw terugbetalen."
		}
	},
	"openInvoices": "Openstaande facturen",
	"attention": {
		"checkStock": "Controleer voorraad vóór verzenden",
		"refund": "Terugbetalen",
		"checkPayment": "Controleer de betaling",
		"createInvoice": "Maak de factuur",
		"checkShippingAddress": "Controleer het verzendadres",
		"resolve": "Afgehandeld",
		"addressChecked": "Adres gecontroleerd",
		"resolvedBy": "Afgehandeld door {{name}} op {{date}}",
		"resolvedAt": "Afgehandeld op {{date}}",
		"failed": "Dat lukte niet. Probeer het nog eens."
	},
	"toShipFilter": {
		"label": "Werkvoorraad",
		"yes": "Te verzenden (betaald)"
	},
	"help": {
		"orders": {
			"title": "Orders",
			"area": "Orders",
			"short": "Alle orders uit de shop, de nieuwste bovenaan. Zoek op ordernummer, naam, e-mailadres of bedrijf, en filter op de drie statussen. Met Werkvoorraad zie je wat je nu kunt verzenden.",
			"terms": ["order:orderNumber", "order:statuses", "order:toShip", "order:order", "invoice:openInvoices"]
		},
		"order": {
			"title": "Order",
			"area": "Orders",
			"short": "Een geplaatste bestelling, met een nummer als CBO-100123. Op de pagina van een order staat alles: de regels, adressen, betaling, factuur en terugbetalingen, en ernaast de klant, de verzending en de historie.",
			"terms": [
				"order:orderNumber",
				"order:statuses",
				"order:snapshot",
				"order:lines",
				"order:shipping",
				"order:refund",
				"order:history"
			],
			"goTo": {
				"to": "/order",
				"label": "Naar Orders"
			}
		},
		"orderNumber": {
			"title": "Ordernummer",
			"area": "Orders",
			"short": "Elke order krijgt bij het plaatsen een nummer: CBO- en een doorlopend nummer vanaf 100000, zonder jaartal. De klant ziet het in de mails en in het klantaccount. Een factuur en een creditfactuur hebben elk een eigen reeks.",
			"terms": ["invoice:invoice", "invoice:creditInvoice"]
		},
		"statuses": {
			"title": "Drie statussen",
			"area": "Orders",
			"short": "Een order heeft drie statussen die los van elkaar bestaan: de betaalstatus, de verzendstatus en de orderstatus. Betaald zegt dus niets over verzonden. De orderstatus volgt vanzelf: afgerond zodra de order betaald en verzonden is.",
			"warning": "De klant ziet de drie statussen niet: in het klantaccount staat één woord, zoals Wordt klaargemaakt of Onderweg.",
			"terms": ["order:paymentStatus", "order:shipmentStatus", "order:orderStatus"]
		},
		"paymentStatus": {
			"title": "Betaalstatus",
			"area": "Orders",
			"short": "Of de order betaald is. Pay.nl meldt een betaling vanzelf; een terugbetaling verandert de betaalstatus ook. Open en verlopen tellen niet mee in de omzet.",
			"choices": [
				{
					"name": "Open",
					"text": "Geplaatst, maar de betaling is nog niet binnen. De voorraad blijft 30 minuten vast, bij een overboeking 7 dagen."
				},
				{
					"name": "Betaald",
					"text": "Pay.nl heeft de betaling gemeld. De order kan verzonden worden."
				},
				{
					"name": "Op rekening",
					"text": "Een zakelijke klant betaalt de factuur later. De order kan meteen verzonden worden."
				},
				{
					"name": "Deels terugbetaald",
					"text": "Een deel is terugbetaald, met een creditfactuur."
				},
				{
					"name": "Terugbetaald",
					"text": "Alles is terugbetaald, met een creditfactuur."
				},
				{
					"name": "Verlopen",
					"text": "Niet op tijd betaald. De order is geannuleerd en de voorraad en de kortingscode komen vrij; er gaat geen mail."
				}
			],
			"terms": ["order:onAccount", "order:refund", "order:statuses", "revenue:counts"]
		},
		"shipmentStatus": {
			"title": "Verzendstatus",
			"area": "Orders",
			"short": "Of de order de deur uit is. Hij gaat op Verzonden zodra je een trackingcode opslaat. Dat kan pas als de order betaald is (ook deels terugbetaald) of op rekening staat.",
			"choices": [
				{
					"name": "Te verzenden",
					"text": "Nog niet verstuurd. Met het filter Werkvoorraad zie je wat betaald is en klaarligt."
				},
				{
					"name": "Verzonden",
					"text": "Verstuurd, met vervoerder en trackingcode. De klant kreeg de track & trace per mail."
				}
			],
			"terms": ["order:trackingCode", "order:toShip", "order:statuses"]
		},
		"orderStatus": {
			"title": "Orderstatus",
			"area": "Orders",
			"short": "Waar de order als geheel staat. Je zet hem niet zelf: hij volgt uit de betaalstatus en de verzendstatus, behalve als je annuleert.",
			"choices": [
				{
					"name": "Open",
					"text": "Nog niet klaar: nog niet betaald, of nog niet verzonden."
				},
				{
					"name": "Afgerond",
					"text": "Betaald (of op rekening) én verzonden. Een terugbetaling daarna verandert dat niet."
				},
				{
					"name": "Geannuleerd",
					"text": "Door jou geannuleerd, niet op tijd betaald, of helemaal terugbetaald voordat hij verzonden was."
				}
			],
			"terms": ["order:cancel", "order:statuses"]
		},
		"toShip": {
			"title": "Werkvoorraad",
			"area": "Orders",
			"short": "Alleen de orders die betaald zijn (ook deels terugbetaald) of op rekening staan, en nog verzonden moeten worden: wat nu de deur uit kan. Een order die op de adrescontrole wacht, staat er niet tussen.",
			"terms": ["order:shipmentStatus", "order:addressCheck"]
		},
		"lines": {
			"title": "Regels",
			"area": "Orders › Regels",
			"short": "Wat de klant bestelde, met per regel de prijs, de korting en de btw, vastgelegd bij het bestellen. Daaronder de verzendkosten, de kortingscode en de totalen.",
			"warning": "Inclusief of exclusief btw hangt af van de klantgroep van de klant bij het bestellen. Bij btw verlegd is de btw 0%.",
			"terms": [
				"order:snapshot",
				"price:customerGroup",
				"price:quantityDiscount",
				"invoice:reverseCharge",
				"customer:customer",
				"discountCode:codes"
			]
		},
		"snapshot": {
			"title": "Vastgelegd bij het bestellen",
			"area": "Orders › Regels",
			"short": "Een order legt bij het plaatsen de adressen, de prijzen en de btw per regel vast. Verandert later het product, de prijs of het adresboek van de klant, dan blijft de order zoals hij was.",
			"terms": ["order:lines", "order:addresses"]
		},
		"addresses": {
			"title": "Adressen",
			"area": "Orders › Adressen",
			"short": "Het verzendadres en het factuuradres zoals de klant ze bij het afrekenen koos, vastgelegd bij het bestellen. Past de klant later zijn adresboek aan, dan verandert deze order niet.",
			"terms": ["order:snapshot", "order:addressCheck"]
		},
		"customer": {
			"title": "Klantgegevens",
			"area": "Orders › Klant",
			"short": "De naam, het e-mailadres en het telefoonnummer die de klant bij het bestellen gaf. Met Naar de klant zie je zijn andere orders, zijn adressen en zijn klantgroep.",
			"terms": ["customer:customer", "price:customerGroup", "customer:customerPrice"]
		},
		"payment": {
			"title": "Betaling",
			"area": "Orders › Betaling",
			"short": "Hoe de klant betaalt en wanneer het binnenkwam. Onder Transacties bij Pay.nl staat elke poging, ook een mislukte of verlopen. Met het transactienummer vind je hem terug in Pay.nl.",
			"terms": ["order:paymentStatus", "order:onAccount"]
		},
		"onAccount": {
			"title": "Op rekening",
			"area": "Orders › Betaling",
			"short": "Een goedgekeurde zakelijke klant bestelt nu en betaalt de factuur later per overboeking, via Pay.nl. De order kan meteen verzonden worden. De factuur moet betaald zijn vóór de vervaldatum.",
			"warning": "Een herinnering gaat nooit vanzelf: die mail je zelf bij Openstaande facturen.",
			"terms": ["invoice:openInvoices", "invoice:invoice", "order:addressCheck"],
			"goTo": {
				"to": "/order/invoices",
				"label": "Naar Openstaande facturen"
			}
		},
		"shipping": {
			"title": "Verzending",
			"area": "Orders › Verzending",
			"short": "Kies de vervoerder en vul de trackingcode in. Bij opslaan gaat de order op Verzonden en krijgt de klant een mail met de track & trace. Dat kan zodra de order betaald is (ook deels terugbetaald) of op rekening staat.",
			"terms": ["order:trackingCode", "order:shipmentStatus", "order:addressCheck"]
		},
		"trackingCode": {
			"title": "Trackingcode",
			"area": "Orders › Verzending",
			"short": "De code van de vervoerder voor dit pakket. De link in de mail en in het klantaccount gaat naar de site van de vervoerder die je kiest: PostNL, DHL, DPD of Bpost.",
			"warning": "Wijzig je de trackingcode, dan krijgt de klant alleen opnieuw een mail als je het vinkje aanzet. De wijziging staat wel in de historie.",
			"terms": ["order:shipmentStatus", "order:history"]
		},
		"addressCheck": {
			"title": "Adrescontrole",
			"area": "Orders › Verzending",
			"short": "Een order op rekening naar een verzendadres dat niet in het adresboek van de klant staat, wacht met verzenden tot je op Adres gecontroleerd klikt. Twijfel je, bel dan eerst de klant.",
			"warning": "Het pakket gaat dan naar een adres dat je nog niet kent, terwijl de factuur pas later betaald wordt. De controle staat ook in de werkvoorraad op Start.",
			"terms": ["order:onAccount"]
		},
		"refund": {
			"title": "Terugbetalen",
			"area": "Orders › Terugbetalingen",
			"short": "Je betaalt volledig of gedeeltelijk terug via Pay.nl: kies de regels en de aantallen, en eventueel de verzendkosten. Het bedrag gaat terug naar de klant, die er een creditfactuur bij krijgt.",
			"choices": [
				{
					"name": "Gedeeltelijk",
					"text": "Een paar regels of minder stuks, bijvoorbeeld bij een retour. De verzendkosten vink je apart aan."
				},
				{
					"name": "Volledig",
					"text": "Met Alles kies je alles wat nog over is. Was de order nog niet verzonden, dan is hij daarna geannuleerd."
				}
			],
			"warning": "Komt het antwoord van Pay.nl niet aan, dan staat de terugbetaling op Onzeker. Kijk in Pay.nl of hij gelukt is en geef het aan; pas dan volgen de creditfactuur en de voorraad.",
			"terms": ["invoice:creditInvoice", "order:restock", "order:paymentStatus", "order:cancel"]
		},
		"restock": {
			"title": "Voorraad terugboeken",
			"area": "Orders › Terugbetalingen",
			"short": "Aan: de stuks die je terugbetaalt, komen terug in de voorraad, als retour bij de voorraadmutaties. Uit: de voorraad blijft gelijk.",
			"terms": ["order:refund"]
		},
		"cancel": {
			"title": "Annuleren",
			"area": "Orders › Annuleren",
			"short": "Hoe je annuleert, hangt af van de betaling. Een verzonden order annuleer je niet meer: betaal dan de teruggestuurde regels terug.",
			"choices": [
				{
					"name": "Niet betaald",
					"text": "Direct, na een bevestiging. De voorraad en de kortingscode komen vrij."
				},
				{
					"name": "Op rekening",
					"text": "Zolang hij niet verzonden is. De factuur krijgt een creditfactuur en de voorraad gaat terug; er gaat niets via Pay.nl."
				},
				{
					"name": "Betaald",
					"text": "Door alles terug te betalen via Pay.nl, met een creditfactuur."
				}
			],
			"warning": "Annuleren kun je niet ongedaan maken. Een reden komt in de historie; de klant ziet hem niet.",
			"terms": ["order:refund", "invoice:creditInvoice", "order:orderStatus"]
		},
		"history": {
			"title": "Historie",
			"area": "Orders › Historie",
			"short": "Alles wat er met de order gebeurde, de nieuwste bovenaan: statussen, betalingen, terugbetalingen, mails en notities, met wie het deed. Een oranje streep is iets wat je nog moet doen; met Afgehandeld is het klaar.",
			"warning": "Wat je nog moet doen, staat ook in de werkvoorraad op Start. Afgehandeld haalt het daar weg.",
			"terms": ["order:note"]
		},
		"note": {
			"title": "Notitie",
			"area": "Orders › Historie",
			"short": "Een notitie voor jezelf en je collega's, bijvoorbeeld over een telefoontje met de klant. Hij komt in de historie met je naam; de klant ziet hem nooit.",
			"terms": ["order:history"]
		}
	},
	"helpExample": {
		"statuses": {
			"animation": "Een order van open via betaald en verzonden naar afgerond.",
			"steps": {
				"placed": "De klant bestelt: de order is open en te verzenden.",
				"paid": "Pay.nl meldt de betaling: de betaalstatus wordt Betaald.",
				"tracking": "Je vult de trackingcode in en slaat op.",
				"shipped": "De verzendstatus wordt Verzonden; de klant krijgt de track & trace.",
				"completed": "De orderstatus gaat vanzelf op Afgerond."
			},
			"sandbox": "Kies de betaalstatus en de verzendstatus, en zie wat de klant in het klantaccount ziet.",
			"notShippable": "Verzenden kan pas als de order betaald is (ook deels terugbetaald) of op rekening staat.",
			"shopLabel": "Het klantaccount in de shop: bestelling {{orderNumber}}, {{stage}}.",
			"placedOn": "5 november 2026"
		},
		"tracking": {
			"shopLabel": "Het klantaccount in de shop: bestelling {{orderNumber}} is onderweg, met de link Volg je pakket."
		}
	}
}
